"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiManager = void 0;
var axios_1 = __importDefault(require("axios"));
var TypeCheck_1 = require("../utils/TypeCheck");
var ApiManager = /** @class */ (function () {
    function ApiManager(initValue) {
        // 전역 설정
        this.defaultInterceptor = function (cb) {
            axios_1.default.interceptors.response.use(function (response) {
                var locale = TypeCheck_1.TypeCheck.itemsByPath(response, 'headers.locale');
                var version = TypeCheck_1.TypeCheck.itemsByPath(response, 'headers.version');
                var userId = TypeCheck_1.TypeCheck.itemsByPath(response, 'headers.user-id');
                // console.log('userId', userId, response);
                if (userId) {
                    cb.callbackUserId(userId);
                }
                // 서버 버전 전달
                cb.callbackServerVersion(version);
                if (locale) {
                    // 한국의 경우 성인 체크버튼 비노출 (정책 적용) 0 비대상 1 대상
                    var result = locale.toLowerCase() === 'kr' ? '0' : '1';
                    // UserDefault.setNormalMode(result);
                    cb.callback(result, locale.toLowerCase());
                }
                return response;
            }, function (error) {
                return Promise.reject(error);
            });
        };
        /**
         * 관리자용 interceptor
         * @param errorCallback
         */
        this.managerInterceptor = function (errorCallback) {
            axios_1.default.interceptors.response.use(function (response) {
                return response;
            }, function (error) {
                var _a;
                // logout 처리
                if (((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === 401) {
                    errorCallback.onErrorLogout();
                }
                return Promise.reject(error);
            });
        };
        // 사용자 로그아웃 처리
        this.userInterceptor = function (errorCallback) {
            axios_1.default.interceptors.response.use(function (response) {
                return response;
            }, function (error) {
                var _a, _b, _c, _d, _e;
                // 접근 에러 (성인인증, ipblock)
                if (((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === 461) {
                    var action = error.response.data.action;
                    errorCallback.onErrorAccessDenied(action);
                    return;
                }
                // logout 처리
                if (((_b = error.response) === null || _b === void 0 ? void 0 : _b.status) === 463) {
                    errorCallback.onErrorLogout();
                }
                // 유출자 경고 페이지 이동
                if (((_c = error.response) === null || _c === void 0 ? void 0 : _c.status) === 465) {
                    errorCallback.onErrorBlockUser();
                }
                if (((_d = error.response) === null || _d === void 0 ? void 0 : _d.status) === 470) {
                    errorCallback.onErrorRedirect();
                }
                // 유출자 & 의심자 회차리스트 접근
                if (((_e = error.response) === null || _e === void 0 ? void 0 : _e.status) === 511) {
                    errorCallback.onErrorDenied();
                }
                return Promise.reject(error);
            });
        };
        // 임시로 any타입 지정
        // axios.defaults.baseURL = process.env.BASE_URL;
        // axios.defaults.headers.common['x-api-key'] = process.env.API_KEY;
        // axios.defaults.headers.common.deviceId = UserDefault.getUdid();
        axios_1.default.defaults.baseURL = initValue.baseUrl;
        var topcoHeader = {
            'x-api-key': initValue.apiKey,
            version: initValue.version,
            deviceId: initValue.uuid,
            partnerCode: "".concat(initValue.partnerCode),
            ua: "".concat(initValue.ua),
            language: "".concat(initValue.language),
            'user-id': "".concat(initValue.userId),
        };
        // 앱 전용 헤더 추가됨
        if (initValue.packageName) {
            topcoHeader = __assign(__assign({}, topcoHeader), { 'package-name': "".concat(initValue.packageName) });
        }
        axios_1.default.defaults.headers.common = topcoHeader;
        if (initValue.partnerCode === undefined) {
            delete axios_1.default.defaults.headers.common.partnerCode;
        }
        if (initValue.ua === undefined) {
            delete axios_1.default.defaults.headers.common.ua;
        }
        axios_1.default.defaults.timeout = 30 * 1000;
        this.instance = axios_1.default;
        // this.defaultInterceptor();
    }
    return ApiManager;
}());
exports.ApiManager = ApiManager;
